import Super from 'client-portal/routes/-request/date';
import classic from 'ember-classic-decorator';

@classic
export default class SiteRequestDate extends Super {}
